module.exports = __webpack_public_path__ + "5a9a305c25dd9d311a964a8764118274.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/lankenau02.jpg
// module id = 799
// module chunks = 0